import React, { useEffect, useState } from "react";

import Carrusel from "../components/Carrusel";

import Emision from "../components/Emision";
import Separador from "../components/Separador";
import Tarjeta from "../components/Tarjeta";
import Terminados from "../components/Terminados";

import supabase from "../config/supabaseCliente";
import estilo from "../styles/Inicio.module.css";
import Reproductor from "../components/Reproductor";

function Inicio() {
  const [lista, setLista] = useState([]);
  const [emision, setEmision] = useState([]);
  const [ultimos, setUltimos] = useState([]);
  const [terminados, setTerminados] = useState([]);

  useEffect(() => {
    const fetchLista = async () => {
      // emision
      try {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .eq("estado", true);

        if (error) {
          console.log("Error", error);
        }

        if (data) {
          setEmision(data);
          // console.log(data);
        }
      } catch (error) {
        console.log("Error");
      }
      //ultimos capitulos
      try {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .order("ultima_modificacion", { ascending: false })
          .range(0, 11);

        if (error) {
          console.log(error);
          setUltimos(null);
        }
        if (data) {
          setUltimos(data);
        }
      } catch (error) {
        console.log("Error Ultimos Animes");
      }
      //animes terminados
      try {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .eq("completado", true)
          .order("ultima_modificacion", { ascending: false })
          .range(0, 5);

        if (error) {
          console.log(error);
          setTerminados(null);
        }
        if (data) {
          // console.log("terminados", data);
          setTerminados(data);
        }
      } catch (error) {
        console.log("Error Lista de Animes");
      }
      // lista
      try {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .range(12, 23)
          .order("id");

        if (error) {
          console.log("Error", error);
        }

        if (data) {
          setLista(data);
          // console.log(data);
        }
      } catch (error) {
        console.log("Error");
      }
    };

    fetchLista();
  }, []);

  return (
    <div>
      {/* <Emision emision={emision}></Emision> */}
      <Reproductor></Reproductor>

      <Separador titulo="Animes Terminados"></Separador>

      <Carrusel lista={lista}></Carrusel>

      <Separador titulo="Últimos Capítulos"></Separador>

      {ultimos && (
        <div className={estilo.tarjeta_ultimos}>
          {ultimos.map((e) => (
            <Tarjeta key={e.id} ultimos={e}></Tarjeta>
          ))}
        </div>
      )}

      <Separador titulo="Animes Terminados"></Separador>

      {terminados && (
        <div className={estilo.tarjeta_terminados}>
          {terminados.map((e) => (
            <Terminados key={e.id} terminados={e}></Terminados>
          ))}
        </div>
      )}
    </div>
  );
}

export default Inicio;
